import { z } from "zod";

/**
 * AssistenciaPesquisaSatisfacaoSchema
 */

export const AssistenciaPesquisaSatisfacaoSchema = z.object({
  pesquisa: z.string().nullable().default(null),
  data: z.coerce.date().nullable().default(null),
  status: z.coerce.number().default(0),
  itens: z.array(z.object({
    idItemPesquisaCliente: z.number(),
    descricao: z.string().nullable().default(null),
    nota: z.number().nullable().default(null),
  })),
});

/**
 * AssistenciaPesquisaSatisfacaoForm
 */

export type AssistenciaPesquisaSatisfacaoForm = z.infer<typeof AssistenciaPesquisaSatisfacaoSchema>;